import React from 'react'
import Icon from './Icon'
import { Link } from 'gatsby'
const OverrideBanner = ({
  currentID,
  address1,
  address2,
  address3,
  address4,
}) => {
  const whichstore = currentID
  const overrideBannerOne = [181]
  const overrideBannerTwo = [527]
  const overrideBannerThree = [479]
  const overrideBannerFour = [493]
  const overrideBannerFive = [520]

  return (
    <section className="relative flex-1">
      {overrideBannerOne.includes(whichstore) ? (
        <>
          <div className="absolute right-0 left-auto hidden -mt-2 -mr-2 rounded-full shadow-lg sm:flex">
            <Icon icon="info" className="h-6 fill-primary" />
          </div>
          <section className="flex flex-1 w-full">
            <div className="flex flex-col items-start justify-center flex-1 w-full p-4 bg-white rounded-md shadow-lg lg:p-6 sm:flex-initial">
              <div className="mb-1">
                <h2 className="text-lg font-semibold leading-tight lg:text-xl text-primary">
                  Morrisons Bishopbriggs
                </h2>
              </div>
              <p className="text-base font-semibold">
                Our new Bishopbriggs store
                <span className="block font-bold">Is now open.</span>
              </p>
              <Link
                className="text-base font-semibold underline text-secondary"
                to="/488/glasgow-bishopbriggs"
              >
                Click here for more details
              </Link>
            </div>
          </section>
        </>
      ) : overrideBannerTwo.includes(whichstore) ? (
        <>
          <div className="absolute right-0 left-auto hidden -mt-2 -mr-2 rounded-full shadow-lg sm:flex">
            <Icon icon="info" className="h-6 fill-primary" />
          </div>
          <section className="flex flex-1 w-full">
            <div className="flex flex-col items-start justify-center flex-1 w-full p-4 bg-white rounded-md shadow-lg lg:p-6 sm:flex-initial">
              <div className="mb-1">
                <h2 className="text-lg font-semibold leading-tight lg:text-xl text-primary">
                  Morrisons Mitcham
                </h2>
              </div>
              <p className="text-base font-semibold">
                Our Mitcham store closed on the 17th March 2023.
                <span className="block font-bold">
                  Your nearest Morrisons is now
                </span>
              </p>
              <Link
                className="text-base font-semibold underline text-secondary"
                to="/411/wimbledon"
              >
                Morrisons Wimbledon
              </Link>
              <Link
                className="text-base font-semibold underline text-secondary"
                to="/576/croydon"
              >
                Morrisons Croydon
              </Link>
              <Link
                className="text-base font-semibold underline text-secondary"
                to="/318/sutton"
              >
                Morrisons Sutton
              </Link>
            </div>
          </section>
        </>
      ) : overrideBannerThree.includes(whichstore) ? (
        <>
          <div className="absolute right-0 left-auto hidden -mt-2 -mr-2 rounded-full shadow-lg sm:flex">
            <Icon icon="info" className="h-6 fill-primary" />
          </div>
          <section className="flex flex-1 w-full">
            <div className="flex flex-col items-start justify-center flex-1 w-full p-4 bg-white rounded-md shadow-lg lg:p-6 sm:flex-initial">
              <div className="mb-1">
                <h2 className="text-lg font-semibold leading-tight lg:text-xl text-primary">
                  Morrisons Brentford
                </h2>
              </div>
              <p className="text-base font-semibold">
                This store closed on the 27th September 2023.
                <span className="block font-bold">
                  Your new Morrisons Brentford Waterside store is now open...
                </span>
              </p>
              <Link
                className="text-base font-semibold underline text-secondary"
                to="/382/brentford-waterside"
              >
                View Morrisons Brentford Waterside, TW8 8EW
              </Link>
            </div>
          </section>
        </>
      ) : overrideBannerFour.includes(whichstore) ? (
        <>
          <div className="absolute right-0 left-auto hidden -mt-2 -mr-2 rounded-full shadow-lg sm:flex">
            <Icon icon="info" className="h-6 fill-primary" />
          </div>
          <section className="flex flex-1 w-full">
            <div className="flex flex-col items-start justify-center flex-1 w-full p-4 bg-white rounded-md shadow-lg lg:p-6 sm:flex-initial">
              <div className="mb-1">
                <h2 className="text-lg font-semibold leading-tight lg:text-xl text-primary">
                  Morrisons Bolton - Breightmet
                </h2>
              </div>
              <p className="text-base font-semibold">
                Our Bolton - Breightmet store closed on the 17th September 2023.
                <span className="block font-bold">
                  Your nearest Morrisons is now
                </span>
              </p>
              <Link
                className="text-base font-semibold underline text-secondary"
                to="/212/harwood"
              >
                Morrisons Harwood
              </Link>
              <Link
                className="text-base font-semibold underline text-secondary"
                to="/45/bolton"
              >
                Morrisons Bolton
              </Link>
              <Link
                className="text-base font-semibold underline text-secondary"
                to="/59/bolton-atlas-mills"
              >
                Morrisons Bolton - Atlas Mills
              </Link>
            </div>
          </section>
        </>
      ) : overrideBannerFive.includes(whichstore) ? (
        <>
          <div className="absolute right-0 left-auto hidden -mt-2 -mr-2 rounded-full shadow-lg sm:flex">
            <Icon icon="info" className="h-6 fill-primary" />
          </div>
          <section className="flex flex-1 w-full">
            <div className="flex flex-col items-start justify-center flex-1 w-full p-4 bg-white rounded-md shadow-lg lg:p-6 sm:flex-initial">
              <div className="mb-1">
                <h2 className="text-lg font-semibold leading-tight lg:text-xl text-primary">
                  Morrisons Faversham
                </h2>
              </div>
              <p className="text-base font-semibold">
                Our Faversham store closed on the 17th September 2023.
                <span className="block font-bold">
                  Your nearest Morrisons is now
                </span>
              </p>
              <Link
                className="text-base font-semibold underline text-secondary"
                to="/558/sittingbourne"
              >
                Morrisons Sittingbourne
              </Link>
              <Link
                className="text-base font-semibold underline text-secondary"
                to="/293/canterbury"
              >
                Morrisons Canterbury
              </Link>
              <Link
                className="text-base font-semibold underline text-secondary"
                to="/572/isle-of-sheppey"
              >
                Morrisons Isle of Sheppey
              </Link>
            </div>
          </section>
        </>
      ) : null}
    </section>
  )
}

export default OverrideBanner
